import React from "react";
import AnnunciFunebri from "../../shared/AnnunciFunebri";

const OrgAnnunciFunebri = ({ orgId }) => {
  return (
    <AnnunciFunebri 
      orgId={orgId}
      showBreadcrumb={false}
      showTitle={true}
    />
  );
};

export default OrgAnnunciFunebri; 